import { Car, Bus, Train, Plane, Bike, Truck, Navigation } from 'lucide-react';

const ICON_MAP = {
  car:    Car,
  bus:    Bus,
  train:  Train,
  flight: Plane,
  taxi:   Car,
  bike:   Bike,
  truck:  Truck,
};

export const getTransportIcon = (modeSlug) =>
  ICON_MAP[modeSlug?.toLowerCase()] || Navigation;
